import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import "./AddAdmin.css";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";

const AddAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, mode, page } = location.state || {};
  const isViewMode = mode === "view";
  const isEditMode = mode === "edit";
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [roles, setRoles] = useState([]);
  const [formData, setFormData] = useState({
    adminId: "",
    adminName: "",
    role: "",
    email: "",
    mobileNumber: "",
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    console.log("AdminData", data);

    if (data && (isViewMode || isEditMode)) {
      const selectedRole = roles.find((r) => r.name === data?.role_name);
      setFormData({
        adminId: data?.admin_code || "",
        adminName: data?.name || "",
        role: selectedRole
          ? { id: selectedRole.value, value: selectedRole.name }
          : { id: "", value: "" },
        email: data?.email || "",
        mobileNumber: data?.mobile || "",
        password: "",
        confirmPassword: "",
      });
    }
  }, [data, isViewMode, isEditMode, roles]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("SADDSLKDAKd", name, value);

    if (name == "role") {
      const selectedRole = roles.find((r) => r.name == value);
      console.log("selectedRole", selectedRole);

      setFormData((prev) => ({
        ...prev,
        role: selectedRole
          ? { id: selectedRole.id, value: selectedRole.name }
          : { id: "", value: "" },
      }));
    } else if (name === "mobileNumber") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value || "",
      }));
    }
  };

  const handleEdit = (e) => {
    console.log("Edit clicked");
    e.preventDefault();

    // Validation logic
    const requiredFields = [
      { key: "adminName", label: "Admin Name" },
      { key: "role", label: "Role" },
      { key: "email", label: "Email ID" },
      { key: "mobileNumber", label: "Mobile Number" },
    ];

    // Add password fields to required list if not in view mode
    if (!isViewMode) {
      requiredFields.push({ key: "password", label: "Password" });
      requiredFields.push({
        key: "confirmPassword",
        label: "Confirm Password",
      });
    }

    // Check for empty fields
    console.log("formData.role", formData.role);

    if (!formData.role?.id) {
      toast.error(`Kindly add the Role field`);
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email || "")) {
      toast.error("Kindly enter a valid Email ID");
      return;
    }

    // Phone number validation
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test((formData.mobileNumber || "").replace(/\D/g, ""))) {
      toast.error("Kindly enter a valid 10-digit Mobile Number");
      return;
    }

    // Password match validation
    if (!isViewMode && formData.password !== formData.confirmPassword) {
      toast.error("Password and Confirm Password must be the same");
      return;
    }

    setLoading(true);
    let payload = {
      name: formData.adminName,
      email: formData.email,
      mobile: formData.mobileNumber,
      password: formData.password,
      role: formData.role?.id,
      status: data?.status,
    };
    console.log("payload Data:", formData, data, payload);

    put(URLS.ADMINURL + data?.id + "/", payload)
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message || "Admin Update successfully");
          setLoading(false);
          setFormData({
            adminId: "",
            adminName: "",
            role: "",
            email: "",
            mobileNumber: "",
            password: "",
            confirmPassword: "",
          });
          navigate("/admin", { state: { page: page || 1 } });
        } else {
          setLoading(false);
          // toast.error(res?.message || "Failed to save admin");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
        // toast.error(err?.message || "An error occurred");
      });
  };

  const handleSave = (e) => {
    e.preventDefault();
    console.log("formData.roleformData.role", formData.role);

    // Validation logic
    const requiredFields = [
      { key: "adminName", label: "Admin Name" },
      // { key: "role", label: "Role" },
      { key: "email", label: "Email ID" },
      { key: "mobileNumber", label: "Mobile Number" },
    ];

    // Add password fields to required list if not in view mode
    if (!isViewMode) {
      requiredFields.push({ key: "password", label: "Password" });
      requiredFields.push({
        key: "confirmPassword",
        label: "Confirm Password",
      });
    }

    if (!formData.role?.id) {
      toast.error(`Kindly add the Role field`);
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email || "")) {
      toast.error("Kindly enter a valid Email ID");
      return;
    }

    // Phone number validation
    // const phoneRegex = /^\d{10}$/;
    // if (!phoneRegex.test((formData.mobileNumber || "").replace(/\D/g, ""))) {
    //   toast.error("Kindly enter a valid 10-digit Mobile Number");
    //   return;
    // }

    const indianMobileRegex = /^[6-9]\d{9}$/;

    if (!indianMobileRegex.test(formData.mobileNumber || "")) {
      toast.error("Kindly enter a valid  mobile number");
      return;
    }

    // Password match validation
    if (!isViewMode && formData.password !== formData.confirmPassword) {
      toast.error("Password and Confirm Password must be the same");
      return;
    }

    console.log("Form Data:", formData);
    setLoading(true);
    let payload = {
      name: formData.adminName,
      email: formData.email,
      mobile: formData.mobileNumber,
      password: formData.password,
      role: formData.role?.id,
    };
    post(URLS.ADMINURL, payload)
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message || "Admin saved successfully");
          setLoading(false);
          setFormData({
            adminId: "",
            adminName: "",
            role: "",
            email: "",
            mobileNumber: "",
            password: "",
            confirmPassword: "",
          });
          navigate("/admin", { state: { page: page || 1 } });
        } else {
          setLoading(false);
          // toast.error(res?.message || "Failed to save admin");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
        // toast.error(err?.message || "An error occurred");
      });
  };
  const userRoles = async () => {
    const res = await get(URLS.USERROLEURL);
    if (res?.status === "success") {
      setRoles(res?.data);
    }
  };

  useEffect(() => {
    userRoles();
  }, []);

  console.log("rolesroles", roles);

  return (
    <>
      <PageHeader
        title={isViewMode ? "View Admin" : "Add Admin"}
        showBackButton={true}
        onBackClick={() => navigate("/admin", { state: { page: page || 1 } })}
      />
      <div className="add-admin-container">
        <form className="add-admin-form" onSubmit={handleSave} noValidate>
          <div className="form-row">
            {isViewMode && (
              <div className="form-group">
                <label>Admin ID</label>
                <input
                  type="text"
                  name="adminId"
                  value={formData.adminId || ""}
                  onChange={handleChange}
                  placeholder="Enter Admin ID"
                  required
                  disabled={isViewMode}
                />
              </div>
            )}
            <div className="form-group">
              <label>Admin Name</label>
              <input
                type="text"
                name="adminName"
                value={formData.adminName || ""}
                onChange={handleChange}
                placeholder="Enter Admin Name"
                required
                disabled={isViewMode}
              />
            </div>
            <div className="form-group">
              <label>Role</label>
              <select
                name="role"
                value={formData.role?.value || ""}
                onChange={handleChange}
                required
                disabled={isViewMode}
                className="role-select"
              >
                <option value="">Select Role</option>
                {(roles || []).map((role) => (
                  <option key={role?.value} value={role?.value}>
                    {role?.name || "Admin"}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Email ID</label>
              <input
                type="text"
                name="email"
                value={formData.email || ""}
                onChange={handleChange}
                placeholder="Enter Email ID"
                required
                disabled={isViewMode}
              />
            </div>
            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="text"
                name="mobileNumber"
                value={formData.mobileNumber || ""}
                onChange={handleChange}
                placeholder="Enter Mobile Number"
                required
                disabled={isViewMode}
                readOnly={isEditMode}
                maxLength={10}
              />
            </div>
            {!isViewMode && (
              <div className="form-group">
                <label>Password</label>
                <div className="password-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password || ""}
                    onChange={handleChange}
                    placeholder="Enter Password"
                    required
                  />
                  <span
                    className="password-toggle-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>
            )}
            {!isViewMode && (
              <div className="form-group">
                <label>Confirm Password</label>
                <div className="password-input-wrapper">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={formData.confirmPassword || ""}
                    onChange={handleChange}
                    placeholder="Enter Confirm Password"
                    required
                  />
                  <span
                    className="password-toggle-icon"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>
            )}
          </div>

          {!isViewMode && (
            <div className="form-actions">
              {isEditMode ? (
                <button
                  type="button"
                  className="btn-edit"
                  onClick={() =>
                    navigate("/admin", { state: { page: page || 1 } })
                  }
                >
                  Back
                </button>
              ) : (
                <button
                  type="button"
                  className="btn-back"
                  onClick={() =>
                    navigate("/admin", { state: { page: page || 1 } })
                  }
                >
                  Back
                </button>
              )}
              <button
                type={isEditMode ? "button" : "submit"}
                className="btn-save"
                onClick={isEditMode ? handleEdit : undefined}
              >
                {isEditMode ? "Update" : "Save"}
              </button>
            </div>
          )}
        </form>
        {loading && <Loader />}
      </div>
    </>
  );
};

export default AddAdmin;
